import Routes from './routes'
import { LicenseInfo } from '@mui/x-license'

LicenseInfo.setLicenseKey('a89253f3dd0b4db3578312b4c0d8368cTz0xMTUxNDcsRT0xNzgyNDMxOTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y')

function App () {
  return <Routes />
}

export default App
